import React from "react";
import { Heading } from "web/react/emo/heading/heading";
import { Text } from "web/react/emo/text/text";
import { VStack } from "web/react/emo/v-stack/v-stack";
import { useSectionImpression } from "web/react/pages/partners/use-section-impression";
import { gettext, gettextNoop } from "web/script/modules/django-i18n";
import * as styles from "./partners-audience.css";

interface StatConfig {
    number: string;
    labelKey: string;
    bodyKey: string;
}

const STATS: StatConfig[] = [
    {
        number: "13M",
        labelKey: gettextNoop("partners.audience.stat_1_label"),
        bodyKey: gettextNoop("partners.audience.stat_1_body"),
    },
    {
        number: "$1085",
        labelKey: gettextNoop("partners.audience.stat_2_label"),
        bodyKey: gettextNoop("partners.audience.stat_2_body"),
    },
    {
        number: "4.64%",
        labelKey: gettextNoop("partners.audience.stat_3_label"),
        bodyKey: gettextNoop("partners.audience.stat_3_body"),
    },
    {
        number: "160M+",
        labelKey: gettextNoop("partners.audience.stat_4_label"),
        bodyKey: gettextNoop("partners.audience.stat_4_body"),
    },
];

export default function PartnersAudience(): JSX.Element {
    const sectionRef = useSectionImpression("audience", 4);

    return (
        <section ref={sectionRef} id="audience" className={styles.section}>
            <div className={styles.container}>
                <div className={styles.header}>
                    <VStack spacing="xs">
                        <Text textStyle="caption-s" color="secondary" className={styles.eyebrow}>
                            {gettext("partners.nav.audience")}
                        </Text>
                        <Heading textStyle="hero-l" as="h2">
                            {gettext("partners.audience.headline")}
                        </Heading>
                    </VStack>
                </div>

                <div className={styles.grid}>
                    {STATS.map(({ number, labelKey, bodyKey }) => (
                        <div key={number} className={styles.statItem}>
                            <Heading textStyle="hero-l">{number}</Heading>
                            <div className={styles.statContent}>
                                <Text
                                    textStyle="caption-s"
                                    color="secondary"
                                    className={styles.statLabel}
                                >
                                    {gettext(labelKey)}
                                </Text>
                                <Text textStyle="body" color="secondary">
                                    {gettext(bodyKey)}
                                </Text>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
